import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { LoginPage } from '@/components/Auth/LoginPage';
import { ProtectedRoute } from '@/components/Auth/ProtectedRoute';
import { AtencionPage } from '@/components/Atencion/AtencionPage';
import { CuadroPage } from '@/components/Cuadro/CuadroPage';
import { Layout } from '@/components/Layout/Layout';
import { useSession } from '@/hooks/useSession';

// /login con sesión activa no tiene sentido: al panel.
function LoginRoute() {
  const { session, loading } = useSession();
  if (loading) return null;
  if (session) return <Navigate to="/atencion" replace />;
  return <LoginPage />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginRoute />} />
        <Route
          path="/atencion"
          element={
            <ProtectedRoute>
              <Layout>
                <AtencionPage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/cuadro"
          element={
            <ProtectedRoute>
              <Layout>
                <CuadroPage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/atencion" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
